export default "__VITE_ASSET__VXlREOwB__"